export default __webpack_public_path__ + "static/media/stackdriver-monitoring.744efeb7.svg";